import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import MainActions from "redux-store/models/main"
import AuthActions from "redux-store/models/auth"
import { withRouter } from "react-router-dom"
import CalendarRangePicker from "shared-components/CalendarRangePicker/CalendarRangePicker"
import { Table, Icon, Select, Button, Input } from "antd"
import moment from "moment"
import { CSVLink } from "react-csv"
import { baseUrlImg } from "../../config/api"

const filterOptions = [
  { value: "company", label: "Compagnia" },
  { value: "category", label: "Categoria" },
  { value: "user", label: "Utente" },
  { value: "service", label: "Servizio" },
  { value: "providers", label: "Provider" },
]

const Reports = ({
  getStatistics,
  stats,
  getCodiceTicket,
  getAllImages,
  images,
  activeSkinId,
  screenWidth,
accountInfo
}) => {
  const [filterType, setFilterType] = useState({
    value: "company",
    label: "Compagnia",
  })

  const [searchText, setSearchText] = useState("")

  const [showCalendar, setShowCalendar] = useState(false)
  const [picker, setPicker] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ])

  const today = moment().format("YYYY-MM-DD")
  const todayLabel = moment().format("DD/MM/YYYY")

  const [from, setFrom] = useState(today)
  const [to, setTo] = useState(today)
  const [fromLabel, setFromLabel] = useState(todayLabel)
  const [toLabel, setToLabel] = useState(todayLabel)

  const [loading, setLoading] = useState(false)
  const [visibleRows, setVisibleRows] = useState([])

  useEffect(() => {
    getAllImages("icon")
  }, [])

  useEffect(() => {
    const fetchFrom = from || today
    const fetchTo = to || today
    getStatistics(
      filterType.value,
      fetchFrom,
      fetchTo,
      setLoading,
      activeSkinId ?? null,
    )
  }, [filterType, activeSkinId])

  const handleDateSelect = (item) => {
    const { startDate, endDate } = item.selection
    setPicker([item.selection])
    setFrom(moment(startDate).format("YYYY-MM-DD"))
    setTo(moment(endDate).format("YYYY-MM-DD"))
    setFromLabel(moment(startDate).format("DD/MM/YYYY"))
    setToLabel(moment(endDate).format("DD/MM/YYYY"))
  }

  const clearDate = () => {
    setFrom(today)
    setTo(today)
    setFromLabel(todayLabel)
    setToLabel(todayLabel)
    setVisibleRows([])
  }

  const dataSource = Object.entries(stats || {}).map(([category, values], index) => {
    const base = {
      key: `parent-${index}`,
      category,
      total_services: Array.isArray(values.payments) ? values.payments.length : 0,
      user_name: values.user ? values.user.username : "",
      company_name: values.company
        ? values.company.full_name || values.company.name
        : "",
      icon_id: values.company ? values.company.icon_id : "",
      ...values,
    }

    const children = Array.isArray(values.payments)
      ? Object.values(
          values.payments.reduce((acc, payment) => {
            const key = payment.service?.service_id

            const companyName = payment.service?.company?.full_name || ""
            const serviceName = payment.service?.name || ""

            const cleanServiceName = serviceName
              .toLowerCase()
              .startsWith(companyName.toLowerCase())
              ? serviceName.substring(companyName.length).trim()
              : serviceName

            if (!acc[key]) {
              acc[key] = {
                key: `service-${index}-${key}`,
                category: `${companyName} - ${cleanServiceName}`,
                isServiceGroup: true,
                total_services: 0,
                total_amount: 0,
                total_agency_guadagno: 0,
                total_agent_guadagno: 0,
                total_skin_guadagno: 0,
                total_system_aggio: 0,
                total_adyen_commission: 0,
                children: [],
              }
            }

            acc[key].total_services += 1
            acc[key].total_amount += Number(payment.cost)
            acc[key].total_agency_guadagno += Number(payment.agency_guadagno)
            acc[key].total_agent_guadagno += Number(payment.agent_guadagno)
            acc[key].total_skin_guadagno += Number(payment.skin_guadagno)
            acc[key].total_system_aggio += Number(payment.system_aggio)
            acc[key].total_adyen_commission += Number(payment.commissione)

            acc[key].children.push({
              key: `payment-${payment.id}`,
              isChild: true,
              executed_date: payment.executed_date,
              barcode: payment.barcode,
              cost: payment.cost,
              total_agency_guadagno: payment.agency_guadagno,
              total_agent_guadagno: payment.agent_guadagno,
              total_skin_guadagno: payment.skin_guadagno,
              total_system_aggio: payment.system_aggio,
              total_adyen_commission: payment.commissione,
              service: payment.service,
            })

            return acc
          }, {}),
        )
      : []

    return {
      ...base,
      children,
    }
  })

  const filteredDataSource = dataSource.filter((row) => {
    if (!searchText) return true

    const text = searchText.toLowerCase()

    return (
      (row.category || "").toLowerCase().includes(text) ||
      (row.user_name || "").toLowerCase().includes(text) ||
      (row.company_name || "").toLowerCase().includes(text)
    )
  })

  const dynamicTitleMap = {
    company: "Compagnia",
    category: "Categoria",
    user: "Utente",
    service: "Servizio",
  }

  const commonColumns = [
    {
      title: dynamicTitleMap[filterType.value] || "Categoria",
      dataIndex: "category",
      key: "category",
      ellipsis: true,
      width: screenWidth > 650 ? "18%" : "30%",
      render: (val, record) => {
        if (record.isChild) {
          return moment(record.executed_date).format("DD/MM/YYYY HH:mm:ss")
        }

        const icon = images.find((img) => img.id === record.icon_id)

        if (record.company_name) {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              {icon && (
                <img
                  src={`${baseUrlImg}/${icon.path_slug}`}
                  alt={icon.name}
                  style={{ height: "25px", width: "25px" }}
                />
              )}
              <span style={{ textTransform: "capitalize" }}>{val}</span>
            </div>
          )
        }

        const text = record.user_name || val

        return text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : ""
      },
    },
    {
      title: "Totale Servizi",
      dataIndex: "total_services",
      key: "total_services",
      align: "center",
      ellipsis: true,
      sorter: (a, b) => a.total_services - b.total_services,
      render: (val, record) =>
        record.isChild ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <a
              style={{
                textDecoration: "underline",
                color: "#0078ff",
                cursor: "pointer",
                maxWidth: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "block",
              }}
            >
              {record.barcode}
            </a>

            {record?.service?.name && (
              <span
                style={{
                  fontSize: "12px",
                  color: "#8a8a8a",
                  marginTop: "2px",
                  maxWidth: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                }}
                title={record.service.name}
              >
                ({record.service.name})
              </span>
            )}
          </div>
        ) : (
          val
        ),
    },
    {
      title: "Totale Importo",
      dataIndex: "total_amount",
      key: "total_amount",
      align: "right",
      ellipsis: true,
      sorter: (a, b) => a.total_amount - b.total_amount,
      render: (val, record) =>
        record.isChild
          ? `${parseFloat(record.cost).toFixed(2)} €`
          : val != null
            ? `${(+val).toFixed(2)} €`
            : "-",
    },
  ]

  const desktopColumns = [
    {
      title: "Comm. Pagamento",
      dataIndex: "total_adyen_commission",
      key: "total_adyen_commission",
      align: "right",
      ellipsis: true,
      sorter: (a, b) => a.total_adyen_commission - b.total_adyen_commission,
      render: (val) => (val != null ? `${(+val).toFixed(2)} €` : "-"),
    },
    {
      title: "Guadagno Agenzia",
      dataIndex: "total_agency_guadagno",
      key: "total_agency_guadagno",
      align: "right",
      ellipsis: true,
      sorter: (a, b) => a.total_agency_guadagno - b.total_agency_guadagno,
      render: (val) => (val != null ? `${(+val).toFixed(3)} €` : "-"),
    },
    {
      title: "Guadagno Agente",
      dataIndex: "total_agent_guadagno",
      key: "total_agent_guadagno",
      ellipsis: true,
      align: "right",
      sorter: (a, b) => a.total_agent_guadagno - b.total_agent_guadagno,
      render: (val) => (val != null ? `${(+val).toFixed(4)} €` : "-"),
    },
    {
      title: "Guadagno Skin",
      dataIndex: "total_skin_guadagno",
      key: "total_skin_guadagno",
      align: "right",
      ellipsis: true,
      sorter: (a, b) => a.total_skin_guadagno - b.total_skin_guadagno,
      render: (val) => (val != null ? `${(+val).toFixed(3)} €` : "-"),
    },
    {
      title: "Aggio Sistema",
      dataIndex: "total_system_aggio",
      key: "total_system_aggio",
      align: "right",
      ellipsis: true,
      sorter: (a, b) => a.total_system_aggio - b.total_system_aggio,
      render: (val) => (val != null ? `${(+val).toFixed(3)} €` : "-"),
    },
  ]

const columns =
  screenWidth > 650
    ? [
        ...commonColumns,
        ...desktopColumns.filter((column) => {
          if (
            accountInfo?.profile?.role?.name === "super_admin" &&
            column.key === "total_system_aggio"
          ) {
            return false
          }

          if (
            accountInfo?.profile?.role?.name  === "agent" &&
            ["total_skin_guadagno", "total_system_aggio"].includes(column.key)
          ) {
            return false
          }

          return true
        }),
      ]
    : commonColumns
  const sourceForTotals = visibleRows.length > 0 ? visibleRows : filteredDataSource

  const totals = sourceForTotals.reduce(
    (acc, row) => {
      acc.total_services += row.total_services || 0
      acc.total_adyen_commission += row.total_adyen_commission || 0
      acc.total_amount += +row.total_amount || 0
      acc.total_agency_guadagno += +row.total_agency_guadagno || 0
      acc.total_agent_guadagno += +row.total_agent_guadagno || 0
      acc.total_skin_guadagno += +row.total_skin_guadagno || 0
      acc.total_system_aggio += +row.total_system_aggio || 0
      return acc
    },
    {
      total_services: 0,
      total_adyen_commission: 0,
      total_amount: 0,
      total_agency_guadagno: 0,
      total_agent_guadagno: 0,
      total_skin_guadagno: 0,
      total_system_aggio: 0,
    },
  )

  const csvHeaders = [
    { label: "Categoria", key: "category" },
    { label: "Utente", key: "user_name" },
    { label: "Compagnia", key: "company_name" },
    { label: "Totale Servizi", key: "total_services" },
    { label: "Comm. Pagamento", key: "total_adyen_commission" },
    { label: "Totale Importo (€)", key: "total_amount" },
    { label: "Guadagno Agenzia (€)", key: "total_agency_guadagno" },
    { label: "Guadagno Agente (€)", key: "total_agent_guadagno" },
    { label: "Guadagno Skin (€)", key: "total_skin_guadagno" },
    { label: "Aggio Sistema (€)", key: "total_system_aggio" },
  ]

  const csvData = dataSource.map((row) => ({
    ...row,
    total_amount: (+row.total_amount || 0).toFixed(4),
    total_agency_guadagno: (+row.total_agency_guadagno || 0).toFixed(4),
    total_agent_guadagno: (+row.total_agent_guadagno || 0).toFixed(4),
    total_skin_guadagno: (+row.total_skin_guadagno || 0).toFixed(4),
    total_system_aggio: (+row.total_system_aggio || 0).toFixed(4),
  }))

  return (
    <div className="reports-container">
      <div className="reports-header">
        <div>
          <h5
            onClick={() => {
              clearDate()
              getStatistics(
                filterType.value,
                today,
                today,
                setLoading,
                activeSkinId ?? null,
              )
            }}
          >
            <Icon type="credit-card" />
            Reports
          </h5>

          <div className="calendar-trigger" onClick={() => setShowCalendar(true)}>
            <i className="fal fa-calendar-alt" />
            <span>
              {fromLabel && toLabel
                ? `${fromLabel} - ${toLabel}`
                : "Seleziona la data"}
            </span>
          </div>
        </div>
        <div>
          <div className="filter-wrapper">
            <Select
              labelInValue
              value={{
                value: filterType.value,
                label: `Filtro: ${filterType.label}`,
              }}
              onChange={(selected) => {
                setFilterType({
                  value: selected.key,
                  label: selected.label,
                })
              }}
              className="filter-select"
            >
              {filterOptions.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </div>

          <Input
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Cerca..."
            style={{
              width: "200px",
              height: "37px",
            }}
            suffix={<Icon type="search" />}
          />
          <div className="export-wrapper">
            <CSVLink
              headers={csvHeaders}
              data={csvData}
              filename={`report_${filterType.value}_${moment().format(
                "YYYYMMDD",
              )}.csv`}
              style={{ textDecoration: "none" }}
            >
              <Button icon="download">Export</Button>
            </CSVLink>
          </div>
        </div>
      </div>

      {showCalendar && (
        <CalendarRangePicker
          picker={picker}
          setCalendar={setShowCalendar}
          handleSubmit={() => {
            getStatistics(
              filterType.value,
              from || today,
              to || today,
              setLoading,
              activeSkinId ?? null,
            )
          }}
          setStateFunc={handleDateSelect}
          setStateFuncEmpty={clearDate}
        />
      )}

      <div className="reports-table-wrapper">
        {loading ? (
          <div className="loaderAdmin"></div>
        ) : (
          <>
            <div className="totals-wrapper">
              <div className="totals-row">
                <div className="totals-box">
                  <span className="label">Totale Servizi</span>
                  <span className="value">
                    {totals.total_services.toLocaleString("it-IT")}
                  </span>
                </div>
                <div className="totals-box">
                  <span className="label">Comm. Pagamento</span>
                  <span className="value">
                    {totals.total_adyen_commission.toLocaleString("it-IT", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}{" "}
                    €
                  </span>
                </div>
                <div className="totals-box">
                  <span className="label">Totale Importo</span>
                  <span className="value">
                    {totals.total_amount.toLocaleString("it-IT", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}{" "}
                    €
                  </span>
                </div>
                <div className="totals-box">
                  <span className="label">Guadagno Agenzia</span>
                  <span className="value">
                    {totals.total_agency_guadagno.toLocaleString("it-IT", {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })}{" "}
                    €
                  </span>
                </div>
                <div className="totals-box">
                  <span className="label">Guadagno Agente</span>
                  <span className="value">
                    {totals.total_agent_guadagno.toLocaleString("it-IT", {
                      minimumFractionDigits: 4,
                      maximumFractionDigits: 4,
                    })}{" "}
                    €
                  </span>
                </div>
                {accountInfo?.profile?.role?.name !== "agent" && (
                <div className="totals-box">
              <span className="label">Guadagno Skin</span>
                  <span className="value">
                 {totals.total_skin_guadagno.toLocaleString("it-IT", {
                 minimumFractionDigits: 3,
                maximumFractionDigits: 3,
      })}{" "}
      €
    </span>
  </div>
)}
               {!["super_admin", "agent"].includes(accountInfo?.profile?.role?.name) && (
  <div className="totals-box">
    <span className="label">Aggio Sistema</span>
    <span className="value">
      {totals.total_system_aggio.toLocaleString("it-IT", {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      })}{" "}
      €
    </span>
  </div>
)}
              </div>
            </div>

            <Table
              className="reports-table-admin"
              dataSource={filteredDataSource}
              columns={columns}
              pagination={false}
              scroll={{ y: "calc(100vh - 315px)" }}
              sticky
              rowClassName={(record) =>
                record.isChild === true ? "row-children" : ""
              }
              onChange={(_, filters, sorter, extra) => {
                setVisibleRows(extra.currentDataSource)
              }}
              onRow={(record) => ({
                onClick: () => {
                  if (record.isChild) {
                    getCodiceTicket(record.barcode, "type")
                  }
                },
              })}
            />
          </>
        )}
      </div>
    </div>
  )
}

const mstp = (state) => ({
  stats: state.main.stats,
  images: state.main.images,
  activeSkinId: state.main.activeSkinId,
  screenWidth: state.main.screenWidth,
  accountInfo: state.auth.accountInfo,
})

export default connect(mstp, { ...MainActions, ...AuthActions })(withRouter(Reports))
